import axios from "axios";
import { handlePaginatedResponse, createPaginatedState } from '../helpers/paginationState';
export const state = {
    agent_stock: createPaginatedState(),
    agents: [],
    filter_status: false,
    save_status: false,
    disbursement_cart: [],
    disbursements: createPaginatedState(),
    stockreturn_cart: [],
    pendingspoilt: createPaginatedState(),
    stockreturns: createPaginatedState(),
    stockvalue: createPaginatedState(),
    agent_disbursements:[],
    reconcilations:createPaginatedState(),

};
export const getters = {
    AgentStock: state => state.agent_stock.data,
    AgentStockPagination: state => state.agent_stock.meta,
    AgentStockPaginated: state => state.agent_stock.data,
    IsAgentStockServerPaginated: state => state.agent_stock.isServerPaginated,
    Agents: state => state.agents,
    FilterStatus: state => state.filter_status,
    SaveStatus: state => state.save_status,
    DisbursementCart: state => state.disbursement_cart.data,
    Disbursements: state => state.disbursements.data,
    DisbursementsPagination: state => state.disbursements.meta,
    DisbursementsPaginated: state => state.disbursements.data,
    IsDisbursementsServerPaginated: state => state.disbursements.isServerPaginated,
    StockreturnCart: state => state.stockreturn_cart.data,
    PendingSpoilt: state => state.pendingspoilt.data,
    PendingSpoiltPagination: state => state.pendingspoilt.meta,
    PendingSpoiltPaginated: state => state.pendingspoilt.data,
    IsPendingSpoiltServerPaginated: state => state.pendingspoilt.isServerPaginated,
    Stockreturns: state => state.stockreturns.data,
    StockreturnsPagination: state => state.stockreturns.meta,
    StockreturnsPaginated: state => state.stockreturns.data,
    IsStockreturnsServerPaginated: state => state.stockreturns.isServerPaginated,
    StockValue: state => state.stockvalue.data,
    StockValuePagination: state => state.stockvalue.meta,
    StockValuePaginated: state => state.stockvalue.data,
    IsStockValueServerPaginated: state => state.stockvalue.isServerPaginated,
    AgentDisbursements: state => state.agent_disbursements.data,
    Reconcilations: state => state.reconcilations.data,
    ReconcilationsPagination: state => state.reconcilations.meta,
    ReconcilationsPaginated: state => state.reconcilations.data,
    IsReconcilationsServerPaginated: state => state.reconcilations.isServerPaginated,
};

export const mutations = {
    SET_AGENTS(state, newValue) {
        state.agents = newValue
    },
    SET_AGENTSTOCK(state, response) {
        handlePaginatedResponse(state.agent_stock, response);  
    },
    SET_FILTERSTATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_DISBURSEMENT_CART(state, newValue) {
        state.disbursement_cart = newValue
    },
    SET_DISBURSEMENTS(state, response) {
        handlePaginatedResponse(state.disbursements, response);  
    },
    SET_AGENT_DISBURSEMENTS(state, newValue) {
        state.agent_disbursements = newValue
    },
    SET_STOCKRETURN_CART(state, newValue) {
        state.stockreturn_cart = newValue
    },
    SET_PENDINGSPOILT(state, newValue) {
        state.pendingspoilt = newValue
    },
    SET_STOCKRETURNS(state, newValue) {
        state.stockreturns = newValue
    },
    SET_STOCKVALUE(state, response) {
        handlePaginatedResponse(state.stockvalue, response);  
    },
    SET_RECONCILATIONS(state, response) {
        handlePaginatedResponse(state.reconcilations, response);  
    },

};

export const actions = {

    fetchAgentstock({ commit, dispatch }, payload={}) {
        commit('SET_FILTERSTATUS', true);

        let id = payload.agent ?? 0;
        let apiPayload = { 
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            product_id: payload.product_id ?? 0,
        };

        axios.get(`agent_stock/${id}`,{params: apiPayload}).then(response => {
            commit('SET_AGENTSTOCK', response.data);
            commit('SET_FILTERSTATUS', false);
        }).catch(() => {
            commit('SET_AGENTSTOCK', { data: [], meta:{} });
            commit('SET_FILTERSTATUS', false);
            let errorMsg = 'Failed to load agent stock.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    fetchAgents({ commit }) {
        axios.get('agents').then(ec_res => {
            commit('SET_AGENTS', ec_res.data)
        })
    },

    // Disbursement Cart
    fetchDisbursementCart({ commit }) {
        axios.get('disbursements_cart').then(ec_res => {
            commit('SET_DISBURSEMENT_CART', ec_res.data)
        })
          
    },


    addToDisbursementCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('disbursements_cart', payload).then(() => {
            dispatch('fetchDisbursementCart');
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Product to cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editDisbursementCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`disbursements_cart/${payload.id}`, payload).then(() => {
            dispatch('fetchDisbursementCart');
            let message = { 'msg': `Product ${payload.name} updated successfully in cart` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Product in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteDisbursementCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`disbursements_cart/${payload.id}`).then(() => {
            dispatch('fetchDisbursementCart');
            let message = { 'msg': `Product ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Product from cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },



    //Disbursement
    fetchDisbursement({ commit, dispatch }, payload) {
          commit('SET_FILTERSTATUS', true);

        let apiPayload = { ...payload };

        apiPayload.page = apiPayload.page ?? 1;
        apiPayload.per_page = apiPayload.per_page ?? 50;

        // Remove agent if 0 (means fetch all agents)
        if (apiPayload.agent === 0 || apiPayload.agent === '' || apiPayload.agent === null) {
            delete apiPayload.agent;
        }

        axios.post('fetchdisbursements', apiPayload).then(response => {
            commit('SET_DISBURSEMENTS', response.data);
            commit('SET_FILTERSTATUS', false);
        }).catch(() => {
            commit('SET_DISBURSEMENTS', { data: [], meta:{} });
            commit('SET_FILTERSTATUS', false);
            let errorMsg = 'Failed to load disbursements.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    fetchAgentDisbursement({ commit }) {
        axios.get('agent_disbursements').then(ec_res => {
            commit('SET_AGENT_DISBURSEMENTS', ec_res.data)
        })
    },

    addToDisbursement({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('disbursements', payload).then(() => {
            dispatch('fetchDisbursementCart');
            let message = { 'msg': `Item disbursement submitted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error submitting disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editDisbursement({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`disbursements/${payload.id}`, payload).then(() => {
            dispatch('fetchDisbursement');
            let message = { 'msg': `Disbursement record updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Disbursement" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteDisbursement({ commit, dispatch }, id) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`disbursements/${id}`).then(() => {
            dispatch('fetchDisbursement');
            let message = { 'msg': `Disbursement has been deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    receiveDisbursement({ commit, dispatch }, id) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`receive_disbursements/${id}`).then(() => {
            dispatch('fetchDisbursement');
            let message = { 'msg': `Disbursement has been received successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in receiving Disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    rejectDisbursement({ commit, dispatch }, id) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`reject_disbursements/${id}`).then(() => {
            dispatch('fetchDisbursement');
            let message = { 'msg': `Disbursement has been rejected successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in rejecting Disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Stock return Cart
    fetchStockreturnCart({ commit }) {
        axios.get('agent_stockreturn_cart').then(ec_res => {
            commit('SET_STOCKRETURN_CART', ec_res.data)
        })
    },

    addToStockreturnCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('agent_stockreturn_cart', payload).then(() => {
            dispatch('fetchStockreturnCart');
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Product to cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editStockreturnCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`agent_stockreturn_cart/${payload.id}`, payload).then(() => {
            dispatch('fetchStockreturnCart');
            let message = { 'msg': `Product ${payload.name} updated successfully in cart` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Product in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteStockreturnCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`agent_stockreturn_cart/${payload.id}`).then(() => {
            dispatch('fetchStockreturnCart');
            let message = { 'msg': `Product ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Product from cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    //
    addReturnedstock({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('agent_stockreturn', payload).then(() => {
            dispatch('fetchStockreturnCart');
            let message = { 'msg': `Item disbursement submitted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error submitting disbursement " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Spoilt Stock/Exchanges
    // Fetch 
    fetchPendingSpoilt({ commit, dispatch }, payload={}) {
        commit('SET_FILTERSTATUS', true);

        let apiPayload = { 
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            agent_id: payload.agent_id ?? 0,
            product_id: payload.product_id ?? 0,
        };

        axios.get('agent_damages',{params: apiPayload}).then(response => {
            commit('SET_PENDINGSPOILT', response.data);
            commit('SET_FILTERSTATUS', false);
        }).catch(() => {
            commit('SET_PENDINGSPOILT', { data: [], meta:{} });
            commit('SET_FILTERSTATUS', false);
            let errorMsg = 'Failed to load pending spoilt stock.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    addSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('agent_damages', payload).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `Spoilt Product awaits confirmation as spoilt ` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Confirm 
    ConfirmSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.get(`confirm_agent_damages/${payload.id}`, payload).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `item ${payload.name} spoilt stock record has been successfully confirmed` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Confirming Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Reject Spoilt Stock
    RejectSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.get(`reject_agent_damages/${payload.id}`, payload).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `item ${payload.name} spoilt stock record has been successfully rejected` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Rejecting Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },


    deleteSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`agent_damages/${payload.id}`).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `Spoilt stock record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchAgentstockReturns({ commit, dispatch }, payload={}) {
         commit('SET_FILTERSTATUS', true);

        let apiPayload = { ...payload };

        apiPayload.page = apiPayload.page ?? 1;
        apiPayload.per_page = apiPayload.per_page ?? 50;

        // Remove agent_id if 0 (All Agents)
        if (apiPayload.agent_id === 0 || apiPayload.agent_id === '' || apiPayload.agent_id === null) {
            delete apiPayload.agent_id;
        }

        axios.get('agent_stockreturn',{params: apiPayload}).then(response => {
            commit('SET_STOCKRETURNS', response.data);
            commit('SET_FILTERSTATUS', false);
        }).catch(() => {
            commit('SET_STOCKRETURNS', { data: [], meta:{} });
            commit('SET_FILTERSTATUS', false);
            let errorMsg = 'Failed to load stock returns.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    fetchAgentstockValue({ commit, dispatch }, payload={}) {
        commit('SET_FILTERSTATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = apiPayload.page ?? 1;
        apiPayload.per_page = apiPayload.per_page ?? 50;

        // Remove agent if 0 (means fetch all agents)
        if (apiPayload.agent === 0 || apiPayload.agent === '' || apiPayload.agent === null) {
            delete apiPayload.agent;
        }

        axios.get('agentstock_value', {params: apiPayload}).then(response => {
            commit('SET_STOCKVALUE', response.data);
            commit('SET_FILTERSTATUS', false);
        }).catch(() => {
            commit('SET_STOCKVALUE', { data: [], meta:{} });
            commit('SET_FILTERSTATUS', false);
            let errorMsg = 'Failed to load stock value.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    // Stock roconciliation
    addQty({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`agent_reconciliation/${payload.product_id}`, payload).then(() => {
            dispatch('fetchAgentstock', payload.agent);
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },
    SaveReconcile({ commit, dispatch }) {
        commit('SET_SAVE_STATUS', true);
        axios.post('save__agent_reconciliation').then(() => {
            let message = { 'msg': `Stock Reconciled successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Reconciling Stock" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchReconcilations({ commit, dispatch },payload={}) {
        commit('SET_FILTERSTATUS', true);
        let apiPayload = { 
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            product_id: payload.product_id ?? 0,
            agent_id: payload.agent_id ?? 0,
            date_from: payload.date_from ?? '',
            date_to: payload.date_to ?? '',
        };

        axios.get('agent_reconciliation', {params: apiPayload}).then(response => {
            commit('SET_RECONCILATIONS', response.data);
            commit('SET_FILTERSTATUS', false);
        }).catch(() => {
            commit('SET_RECONCILATIONS', { data: [], meta:{} });
            commit('SET_FILTERSTATUS', false);
            let errorMsg = 'Failed to load reconciliation report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

};